import type * as Types from '../../__generated__/globalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type UserSessionQuery_web_WebQuery_userSession_Session_human_Human = {
  __typename: 'Human',
  token: string,
  customer_uuid: string | null,
  email: string | null,
  first_name: string | null,
  full_name: string | null,
  primary_phone: string | null,
  impersonated: boolean | null,
  opendoor_internal_access: boolean | null
};

export type UserSessionQuery_web_WebQuery_userSession_Session = {
  __typename: 'Session',
  human: UserSessionQuery_web_WebQuery_userSession_Session_human_Human | null
};

export type UserSessionQuery_web_WebQuery = {
  __typename: 'WebQuery',
  userSession: UserSessionQuery_web_WebQuery_userSession_Session | null
};

export type UserSessionQuery_Query = {
  web: UserSessionQuery_web_WebQuery
};


export type UserSessionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserSessionQuery = UserSessionQuery_Query;


export const UserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"human"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customer_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"impersonated"}},{"kind":"Field","name":{"kind":"Name","value":"opendoor_internal_access"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSessionQuery, UserSessionQueryVariables>;